import { Divider, Typography } from "@mui/material";
import React from "react";
import { IoCloseOutline } from "react-icons/io5";
import {
  StyledMainContainer,
  StyledModalContainer,
} from "../../../../pages/Layout/styles";
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DISPLAY_FORMAT,
  formatDateToString,
} from "../../../../utils/date";
import {
  StyledCloseIcon,
  StyledDescriptionModal,
  StyledDetailsHeader,
  StyledDetailsHeaderFloatWrapper,
  StyledDetailsHeaderText,
  StyledStreakWrapper,
  StyledTaskDetailsBody,
  StyledTaskDetailsBodyLeft,
  StyledTaskDetailsBodyRight,
  StyledTaskDetailsIcon,
  StyledTaskDetailsInfo,
  StyledTaskDetailsModal,
} from "./styles";

const TaskDetailsModal = ({ data, setShowModal }) => {
  return (
    <StyledModalContainer>
      <StyledMainContainer>
        <StyledDescriptionModal>
          <StyledDetailsHeaderFloatWrapper>
            <StyledStreakWrapper>
              <Typography>{data.streak}</Typography>
            </StyledStreakWrapper>
            <StyledCloseIcon onClick={() => setShowModal(false)}>
              <IoCloseOutline size="30px" />
            </StyledCloseIcon>
          </StyledDetailsHeaderFloatWrapper>
          <StyledTaskDetailsModal>
            <StyledDetailsHeader>
              <StyledTaskDetailsIcon>
                <Typography variant="h4">{data.emoji}</Typography>
              </StyledTaskDetailsIcon>
              <StyledDetailsHeaderText>
                <Typography variant="h6">{data.title}</Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  {data.description}
                </Typography>
              </StyledDetailsHeaderText>
            </StyledDetailsHeader>
            <Divider />
            <StyledTaskDetailsBody>
              <StyledTaskDetailsBodyLeft>
                <StyledTaskDetailsInfo>
                  <Typography variant="body1" color="textPrimary">
                    Last completed on:
                  </Typography>
                  <Typography variant="body1" color="textPrimary">
                    {formatDateToString(
                      data.lastCompletedOn,
                      DEFAULT_DISPLAY_FORMAT,
                      DEFAULT_DATE_FORMAT
                    )}
                  </Typography>
                </StyledTaskDetailsInfo>
                <StyledTaskDetailsInfo>
                  <Typography variant="body1" color="textPrimary">
                    Created on:
                  </Typography>
                  <Typography variant="body1" color="textPrimary">
                    {formatDateToString(data.createdAt, DEFAULT_DISPLAY_FORMAT)}
                  </Typography>
                </StyledTaskDetailsInfo>
              </StyledTaskDetailsBodyLeft>
              <StyledTaskDetailsBodyRight>
              <StyledTaskDetailsInfo>
                  <Typography variant="body1" color="textPrimary">
                    Notifications:
                  </Typography>
                  <Typography variant="body1" color="textPrimary">
                    {data.enableNotifications ? "Enabled" : "Disabled"}
                  </Typography>
                </StyledTaskDetailsInfo>
                {data.enableNotifications && (
                  <StyledTaskDetailsInfo>
                    <Typography variant="body1" color="textPrimary">
                      Notify On:
                    </Typography>
                    <Typography variant="body1" color="textPrimary">
                      {data.notifyOnDesc}
                    </Typography>
                  </StyledTaskDetailsInfo>
                )}
              </StyledTaskDetailsBodyRight>
            </StyledTaskDetailsBody>
          </StyledTaskDetailsModal>
        </StyledDescriptionModal>
      </StyledMainContainer>
    </StyledModalContainer>
  );
};

export default TaskDetailsModal;
